import { uiBase } from '../../env/constants'

export const loginURL = uiBase +'login'
